import { extractBranchFromUrl } from '../../url/extractBranchFromUrl';

export const openPackingNotePrint = (packingNoteNumber: number): void => {
    const umbrellaBranch = extractBranchFromUrl();
    const branchPrefix = umbrellaBranch ? `/${umbrellaBranch}` : '';
    const printUrl = `${branchPrefix}/print/orders-packing-note/${packingNoteNumber}`;

    window.open(printUrl, '_blank');
};
